export default (translate, regex) => {
  return [
    (value) => {
      if (!value) {
        return translate('PINCODEREQUIRED');
      } else if (regex.test(value) && value.length < 4) {
        return translate('PINCODE_LIMITS');
      } else if (!regex.test(value)) {
        return translate('PINCODE_DIGITS_ONLY');
      } else {
        return true;
      }
    },
  ];
};
